(ns shared.core.amelia-light.components.dropdown
  (:require [shared.core.components.icon :as icon]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [shared.core.util :as util]
            [shared.core.components.button :as button]
            [shared.core.components.input :as input]
            [shared.core.components.modals.views :as modal]
            [shared.core.components.dropdown :as dropdown]
            [shared.core.components.h :as h]
            [shared.core.components.label :as lbl]
            ["@up/extended-ui/components/dropdown/dropdown" :default Dropdown]
            ["@up/extended-ui/components/dropdown/multiple-dropdown" :default MultipleDropdown]
            ["@up/base-ui/components/ui/popover" :refer [Popover PopoverTrigger PopoverContent]]
            ["@up/base-ui/components/ui/command" :refer [Command CommandInput CommandList CommandEmpty CommandGroup CommandItem]]
            ["@up/base-ui/components/ui/dropdown-menu" :refer [DropdownMenu DropdownMenuTrigger DropdownMenuContent DropdownMenuItem DropdownMenuLabel DropdownMenuSeparator DropdownMenuSub DropdownMenuSubTrigger DropdownMenuSubContent DropdownMenuGroup]]
            [shared.core.amelia-light.components.icon :as alc-icon]))

(def dropdown-class-name "amelia-light-dropdown")

(defn dropdown-class-name-with [with-str]
  (str "." dropdown-class-name ".novo-dropdown" with-str))

(def border-0-06 "1px solid rgba(0, 0, 0, 0.06)")

(def pre-icon-style {:color (style/black-rgba 0.4)
                     :font-size 12
                     :left 6})

(style/add-css [(str (dropdown-class-name-with ".ui.search, ")
                     (dropdown-class-name-with ".ui.search.active, ")
                     (dropdown-class-name-with ".ui.search.active:hover"))
                {:border-top border-0-06
                 :border-right border-0-06
                 :border-left border-0-06
                 :border-bottom "1px solid rgba(0, 0, 0, 0.12)"}]
               [(str (dropdown-class-name-with ".ui.selection.active.dropdown, ")
                     (dropdown-class-name-with ".ui.selection.active.dropdown .menu, ")
                     (dropdown-class-name-with ".ui.selection.active.dropdown:hover, ")
                     (dropdown-class-name-with ".ui.selection.active.dropdown:hover .menu, ")
                     (dropdown-class-name-with ".ui.selection.active.dropdown:focus .menu"))
                {:box-shadow "0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 6px 18px 0 rgba(0, 0, 0, 0.08)"}]
               [(dropdown-class-name-with ".ui.selection.active.dropdown .menu")
                {:border-top "none"
                 :border-right border-0-06
                 :border-bottom border-0-06
                 :border-left border-0-06
                 :max-height "193px"}]
               [(dropdown-class-name-with ".novo-dropdown.ui.search")
                {:padding "6px"}]
               [(str (dropdown-class-name-with ".novo-dropdown.ui.search.pre-icon, ")
                     (dropdown-class-name-with ".novo-dropdown.ui.search.selection.dropdown>input.search"))
                {:padding "6px 6px 6px 22px"}]
               [(dropdown-class-name-with ".novo-dropdown.ui.search.selection.dropdown>.text")
                {:color "rgba(0, 0, 0, 0.4) !important"
                 :font-size "12px"}]
               [(dropdown-class-name-with ".novo-dropdown.ui.search.selection.dropdown>input.search")
                {:color "rgba(0, 0, 0, 0.8) !important"}]
               [(dropdown-class-name-with ".novo-dropdown.ui.selection.dropdown>.dropdown.icon")
                {:display "none"}]
               [(dropdown-class-name-with ".novo-dropdown.ui.search.active .menu>.item")
                {:border "none"
                 :padding "6px 6px 6px 8px !important"}]
               [(dropdown-class-name-with ".novo-dropdown.ui.search.active .menu>.item:hover")
                {:background-color "rgba(0, 0, 0, 0.03)"}])

(defn dropdown [args]
  [dropdown/dropdown (merge args
                            {:class-name dropdown-class-name})])

(defn searchable-dropdown [{:keys [val-subscribe form-path form-name]}]
  (let [val- (if val-subscribe
               (re/subscribe val-subscribe)
               (when (and form-path form-name)
                 (re/subscribe [:form/val- form-path form-name])))
        initialized?* (re/ratom false)]
    (fn [{:keys [value label label-class-name label-info required? label-cmp default-value search-placeholder
                 container-style options dropdown-container-style extra-on-select]
          :as config}]
      (let [v (or value (when val- @val-))
            search-placeholder (or search-placeholder "Search")
            sel-fn (fn [e d]
                     (let [val (some-> (aget d "value")
                                       (js->clj))]
                       (when (and form-path form-name)
                         (re/dispatch [:form/change
                                       form-path
                                       form-name
                                       val]))
                       (when extra-on-select
                         (extra-on-select val)))
                     (util/stop-event e))]

        ;; set default into the form only once if empty
        (when (and (not @initialized?*)
                   (seq default-value)
                   (empty? v)
                   form-path form-name)
          (reset! initialized?* true)
          (re/dispatch [:form/change form-path form-name (vec default-value)]))

        [:div {:style (merge {:position :relative}
                             container-style)}
         (when label
           (into [(or label-cmp lbl/label) {:class-name label-class-name
                                            :required? required?
                                            :info-tooltip label-info}]
                 [label]))
         [dropdown/dropdown (merge config
                                   {:class-name dropdown-class-name
                                    :pre-material-icon :search
                                    :pre-icon-style pre-icon-style
                                    :placeholder search-placeholder
                                    :container-style dropdown-container-style
                                    :text search-placeholder
                                    :auto-focus? true
                                    :close-on-change? false
                                    :on-change sel-fn
                                    :select-on-navigation? false
                                    :options (mapv (fn [{:keys [text value search]}]
                                                     {:text text
                                                      :value value
                                                      :search (or search (str text " " value))
                                                      :on-click sel-fn})
                                                   options)})]]))))

(defn up-dropdown [{:keys [options form-path form-name value on-change] :as args}]
  (let [form-val- (when (and form-path form-name)
                    (re/subscribe [:form/val- form-path form-name]))
        value (if (nil? value)
                (when form-val- @form-val-)
                value)
        on-change (or on-change
                      (when (and form-path form-name)
                        (fn [v]
                          (re/dispatch [:form/change form-path form-name v]))))]
    [:> Dropdown (cond-> (dissoc args :form-path :form-name)
                         :always (assoc :options (clj->js options))
                         (not (nil? value)) (assoc :value value)
                         on-change (assoc :on-change on-change))]))

(defn up-multiple-dropdown [{:keys [val-subscribe form-path form-name]}]
  (let [val- (cond
               val-subscribe (re/subscribe val-subscribe)
               (and form-path form-name) (re/subscribe [:form/val- form-path form-name])
               form-path (re/subscribe [:form/form- form-path]))]
    (fn [{:keys [value options on-change] :as args}]
      (let [vs (vec (or (when val- @val-) value []))
            ;; React's strict equality fails on objects, so encode complex values to stable string keys
            ->key (fn [v] (if (or (string? v) (number? v) (keyword? v) (nil? v)) v (pr-str v)))
            key->val (into {} (map (juxt (comp ->key :value) :value)) options)
            on-change* (fn [new-values]
                         (let [v (mapv (fn [k] (get key->val k k)) (js->clj new-values))]
                           (cond
                             (and form-path form-name)
                             (re/dispatch [:form/change form-path form-name v])

                             form-path
                             (re/dispatch [:form/init form-path v]))
                           (when on-change
                             (on-change v))))
            options* (mapv (fn [opt]
                             (cond-> opt
                                     (vector? (:text opt)) (update :text re/as-element)
                                     true (update :value ->key)))
                           options)]
        [:> MultipleDropdown (-> args
                                 (assoc :options (clj->js options*)
                                        :values (clj->js (mapv ->key vs))
                                        :on-change on-change*)
                                 (dissoc :value :form-path :form-name :val-subscribe))]))))

(defn image-circle [{:keys [url]}]
  [:div {:style {:background-color (style/alc-color "Common/White")
                 :background-image (str "url(" url ")")
                 :background-position "50%, 50%"
                 :background-repeat :no-repeat
                 :background-size :contain
                 :border (str "1px solid " (style/alc-color "Border/secondary_inp"))
                 :border-radius "50%"
                 :flex "0 0 24px"
                 :height 24
                 :width 24}}])

(defn- click-inside-popover? [e popover-id]
  (when-let [el (.querySelector js/document (str "[data-up-popover-id=\"" popover-id "\"]"))]
    (let [orig (some-> e .-detail .-originalEvent)
          x (some-> orig .-clientX)
          y (some-> orig .-clientY)]
      (when (and x y)
        (let [rect (.getBoundingClientRect el)]
          (and (>= x (.-left rect))
               (<= x (.-right rect))
               (>= y (.-top rect))
               (<= y (.-bottom rect))))))))

(defn up-popover [_]
  (let [popover-id (str (gensym "up-popover-"))]
    (fn [{:keys [open on-open-change modal trigger content side align side-offset collision-padding class-name
                 on-pointer-down-outside]}]
      [:> Popover (cond-> {}
                          (some? open) (assoc :open open)
                          on-open-change (assoc :on-open-change on-open-change)
                          (some? modal) (assoc :modal modal))
       [:> PopoverTrigger {:as-child true} trigger]
       [:> PopoverContent (cond-> {"data-up-popover-id" popover-id
                                   :on-pointer-down-outside
                                   (fn [e]
                                     (if (click-inside-popover? e popover-id)
                                       (.preventDefault e)
                                       (when on-pointer-down-outside (on-pointer-down-outside e))))}
                                  side (assoc :side (name side))
                                  align (assoc :align (name align))
                                  side-offset (assoc :side-offset side-offset)
                                  collision-padding (assoc :collision-padding collision-padding)
                                  class-name (assoc :class-name class-name))
        content]])))

(defn up-popover-button-dropdown [_]
  (let [open?* (re/ratom false)]
    (fn [{:keys [placeholder image-url fixed-icon-type search? search-placeholder loading-placeholder no-results-message
                 on-change options clearable? loading disabled]}]
      (let [selected-option (some->> options (filterv :selected?) (first))]
        [:> Popover {:open (and @open?* (not disabled))
                     :on-open-change #(reset! open?* %)}
         [:> PopoverTrigger {:as-child true}
          [:button {:type "button"
                    :class-name (str "inline-flex items-center gap-2 overflow-hidden rounded-md px-2 py-2 text-sm "
                                     "font-medium text-foreground transition-colors hover:bg-accent "
                                     "hover:text-accent-foreground disabled:pointer-events-none disabled:opacity-50")
                    :aria-expanded @open?*
                    :disabled (boolean disabled)
                    :style {:cursor (if disabled :default :pointer)}}
           (cond
             image-url
             [image-circle {:url image-url}]

             fixed-icon-type
             [alc-icon/up-secondary-icon {:icon-type fixed-icon-type}]

             (:icon-type selected-option)
             [alc-icon/up-icon {:icon-type (:icon-type selected-option)}])
           [:span {:class-name "truncate"}
            (or (:text selected-option) placeholder)]
           (if (and clearable? selected-option (not disabled))
             [:span {:role "button"
                     :tab-index 0
                     :aria-label "Clear selection"
                     :class-name "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-sm text-foreground opacity-60 transition-opacity hover:opacity-100"
                     :style {:cursor :pointer}
                     :on-click (fn [e]
                                 (.stopPropagation e)
                                 (.preventDefault e)
                                 (on-change nil))
                     :on-key-down (fn [e]
                                    (when (or (= (.-key e) "Enter") (= (.-key e) " "))
                                      (.stopPropagation e)
                                      (.preventDefault e)
                                      (on-change nil)))}
              [alc-icon/up-icon {:icon-type :CrossIcon
                                 :class-name "h-3 w-3"}]]
             [alc-icon/up-icon {:icon-type :ChevronDownIcon
                                :class-name (str "h-4 w-4 shrink-0 transition-transform duration-200"
                                                 (when @open?* " -rotate-180"))}])]]
         [:> PopoverContent {:class-name "w-max p-0"}
          [:> Command
           (when search?
             [:> CommandInput {:disabled loading
                               :placeholder (if loading
                                              (or loading-placeholder "Loading...")
                                              search-placeholder)}])
           [:> CommandList
            [:> CommandEmpty (or no-results-message "No results found.")]
            [:> CommandGroup
             (for [{:keys [text value icon-type selected?]} options]
               ^{:key value}
               [:> CommandItem {:value text
                                :on-select (fn []
                                             (on-change value)
                                             (reset! open?* false))}
                (when icon-type
                  [alc-icon/up-secondary-icon {:icon-type icon-type}])
                text
                [alc-icon/up-icon {:icon-type :DoneIcon
                                   :class-name (str "ml-auto "
                                                    (if selected?
                                                      "opacity-100"
                                                      "opacity-0"))}]])]]]]]))))

(defn up-searchable-list
  [{:keys [options search-placeholder no-results-message on-select]}]
  [:> Command
   [:> CommandInput {:placeholder (or search-placeholder "Search")}]
   [:> CommandList
    [:> CommandEmpty (or no-results-message "No results found.")]
    [:> CommandGroup
     (for [{:keys [text value icon-type]} options]
       ^{:key (pr-str value)}
       [:> CommandItem {:value (or text (pr-str value))
                        :on-select (fn [] (on-select value))}
        (when icon-type
          [alc-icon/up-secondary-icon {:icon-type icon-type}])
        text])]]])

(defn up-dropdown-menu [& args] (into [:> DropdownMenu] args))
(defn up-dropdown-menu-trigger [& args] (into [:> DropdownMenuTrigger] args))
(defn up-dropdown-menu-content [& args] (into [:> DropdownMenuContent] args))
(defn up-dropdown-menu-item [& args] (into [:> DropdownMenuItem] args))
(defn up-dropdown-menu-label [& args] (into [:> DropdownMenuLabel] args))
(defn up-dropdown-menu-separator [& args] (into [:> DropdownMenuSeparator] args))
(defn up-dropdown-menu-group [& args] (into [:> DropdownMenuGroup] args))
(defn up-dropdown-menu-sub [& args] (into [:> DropdownMenuSub] args))
(defn up-dropdown-menu-sub-trigger [& args] (into [:> DropdownMenuSubTrigger] args))
(defn up-dropdown-menu-sub-content [& args] (into [:> DropdownMenuSubContent] args))
